"use client";
import useStore from "@/lib/state";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

const internalPageWrapperStyles = cva(
  "relative flex flex-col h-full py-4 m-2 internal-page overflow-hidden transition-all duration-500 rounded-base bg-background 2xl:m-6 lg:py-6",
  {
    variants: {
      showBanner: {
        true: "",
        false: "",
      },
    },
    defaultVariants: {
      showBanner: true,
    },
  }
);

export function InternalPageWrapper({ children, className = "" }) {
  const { showBanner } = useStore();

  return (
    <div
      className={cn(internalPageWrapperStyles({ showBanner }), className)}
    >
      {children}
    </div>
  );
}
